import React, { memo } from "react";
import classes from "./Header.scss";
import classNames from "classnames";

const Header = props => {
  const { headerClass, children } = props;

  const containerClass = classNames(classes.container, headerClass);
  return <div className={containerClass}>{children}</div>;
};

export default memo(Header);
